// default rounding function for display
// we could have this round by .25, but for the MES data they still want it rounded to .01 instead
// for time entry, there is a separate rounding function in TimesheetNumberCell that will round input to .25
export default function round(value) {
  return Math.round(value * 100) / 100;
}
